import { render, staticRenderFns } from "./inde.vue?vue&type=template&id=279ac4cd"
import script from "./inde.vue?vue&type=script&lang=js"
export * from "./inde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports